import { Pipe, PipeTransform } from '@angular/core';
import { Media } from '@models/media/media.model';
import { get } from 'lodash';

@Pipe({ name: 'thumbnail' })
export class ThumbnailPipe implements PipeTransform {
  transform(value: Media | null, ...args: any[]): any {
    // return get(value, 'children.0.url', get(value, 'url', null)); // TODO
    return get(value, 'url', '');
  }
}
